import { map, assocPath } from 'ramda'
const pages = [
  /* 抖音码截图页面 */
  {
    path: '/screenshots/product-dy-code',
    name: 'douyin-code-page',
    component: () => import(/* webpackChunkName: "douyin-code-page" */ '@/views/screenshots/product-dy-code.vue'),
    meta: {
      scrollToTop: true
    }
  }
]

export default pages |> map(assocPath(['meta', 'requireLogin'], false))
